import React from 'react';
import { connect } from 'react-redux';

import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import * as authActions from '../auth.actions';
import LoginForm from './LoginForm';
import { Localize } from '../../../locale/localization';

const constraints = {
  email: {
    email: {
      message: `^${Localize('form.login.email.error')}`
    }
  },
  password: {
    presence: {
      message: `^${Localize('form.login.password.error')}`
    },
  },
};

class LoginFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      email: '',
      password: '',
    };

    this.state = {
      ...this.state,
      formData,
    };
  }

  getConstraints = () => constraints;

  doSubmit = (formData) => {
    const { loginUser } = this.props;
    loginUser({
      username: formData.email,
      password: formData.password
    }).then((action) => {
      if(action && action.response && action.response.status && action.response.status === 'ok') {
      } else {
        let key = 'form.login.error';
        if(action.error && action.error.message) {
          switch(action.error.message) {
            case 'This email is not registered.':
              key += '.email';
              break;
            case 'This password is not correct.':
              key += '.password';
              break;
            default :;
          }
        }
        this.setState({
          isSubmitting: false,
          submitFailed: true,
          submitted: true,
          formError: Localize(key),
        });
      }
    });
  }

  render() {
    return (
      <LoginForm
        enabled={!this.state.isSubmitting}
        onSubmit={this.onSubmit}
        onInputChange={this.onInputChange}
        onBlur={this.onBlur}
        errors={this.state.errors}
        touchedFields={this.state.touchedFields}
        isValid={this.state.isValid}  
        email={this.state.formData.email}
        password={this.state.formData.password}
        formError={this.state.formError}
      />
    );
  }
}


const mapStateToProps = (state) => {
  return {

  };
};

const ConnectedLoginFormContainer = connect(
  mapStateToProps,
  authActions,
)(LoginFormContainer);

export default ConnectedLoginFormContainer;


// WEBPACK FOOTER //
// ./src/modules/auth/components/LoginFormContainer.js